// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__oPM33","header":"Messages_header__1iOjU"};